import Vue from 'vue'
import Router from 'vue-router'

/* Layout */
import Layout from '@/layout'

import epcRouter from './modules/epc'
// import systemRouter from './modules/system'
import userManualRouter from './modules/userManual'
// import noticeRouter from './modules/notice'
import technicalSupportRouter from './modules/technicalSupport'
// import overseasRouter from './modules/overseas'
import paymentRouter from './modules/payment'
// aboutUsRouter,


/* Router Modules */

Vue.use(Router)

/* Router Modules */

export const constantRoutes = [

  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/login'),
    hidden: true
  },
  {
    path: '/usrLogin',
    component: () => import('@/views/login/usrLogin'),
    hidden: true
  },
  {
    path: '/globalLogin',
    component: () => import('@/views/login/globalLogin'),
    hidden: true
  },
  // {
  //   path: '/visitor',
  //   component: () => import('@/views/public/visitor'),
  //   hidden: true
  // },
  {
    path: '/overseas',
    component: () => import('@/views/public/overseas'),
    hidden: true
  },
  // {
  //   path: '/auth-redirect',
  //   component: () => import('@/views/login/auth-redirect'),
  //   hidden: true
  // },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },
  // {
  //   path: '/public',
  //   component: () => import('@/views/error-page/public'),
  //   hidden: true
  // },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        component: () => import('@/views/dashboard/index'),
        name: 'Home',
        meta: { title: 'routeHome', icon: 'frame10', affix: true }
      }
    ]
  },
  {
    path: '/register',
    component: () => import('@/views/login/usrLogin.vue'),
    hidden: true
  }
  // meta: { title: 'routeVehicle', icon: 'car', noCache: true }   noCache: true表示页面不用缓存
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  {
    path: '/vehicle',
    component: Layout,
    redirect: '/vehicleInfo',
    children: [
      {
        path: 'vehicleInfo',
        component: () => import('@/views/vehicle/vehicleInfo'),
        name: 'VehicleInfo',
        meta: { title: 'routeVehicle', icon: 'car', code: 'epc:vin' }
      }
    ]
  },
  {
    path: '/repairMaterial',
    component: Layout,
    meta: {
      title: 'routeRepair',
      icon: 'vector7'
    },
    children: [
      {
        path: 'searchParts',
        component: () => import('@/views/repairMaterial/searchParts'),
        name: 'SearchParts',
        meta: { title: 'routeSearchParts', icon: 'search-folder', code: 'epc:part' },
        hidden: true
      },
      {
        path: 'summary',
        component: () => import('@/views/repairMaterial/summary'),
        name: 'Summary',
        meta: { title: 'routeSystemOverview', icon: 'xitonggaishu', code: 'Information:overview' }
      },
      {
        path: 'modelNavigation',
        component: () => import('@/views/repairMaterial/modelNavigation'),
        name: 'ModelNavigation',
        meta: { title: 'routeTechnical', icon: 'frame14', code: 'Information:technical' }
      },
      {
        path: 'schematic',
        component: () => import('@/views/repairMaterial/schematic'),
        name: 'Schematic',
        meta: { title: 'routeCircuit', icon: 'frame12', code: 'Information:diagraml' }
      },
      {
        path: 'maintain',
        component: () => import('@/views/repairMaterial/maintain'),
        name: 'Maintain',
        meta: { title: 'routeMaintenance', icon: 'weixiubaoyang', code: 'Information:maintenance' }
      }
    ]
  },
  userManualRouter,
  epcRouter,
  technicalSupportRouter,
  paymentRouter,
  /** 后台管理 **/
  // noticeRouter,
  // systemRouter,
  // overseasRouter,
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true },
  {
    path: '/general-info',
    component: Layout,
    name: 'GeneralInfo',
    meta: {
      title: 'routeGeneralInfo',
      icon: 'generalInfo',
      code: 'general:info:page'
    },
    children: [
      {
        path: 'index',
        component: () => import('@/views/generalInfo/index'),
        name: 'GeneralInfoIndex',
        meta: {
          title: 'routeGeneralInfo',
          icon: 'generalInfo',
          code: 'epc:vin'
        }
      }
    ]
  }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
